export default {
  forms: {
    section: {
      textLabel: 'Section title',
      selectLabel: 'Select a section',
    },
    subSection: {
      textLabel: 'Sub-section title',
      selectLabel: 'Select a sub-section',
    },
    group: {
      label: 'Group title',
      description: { label: 'Group description', placeholder: 'Description' },
      unit: {
        label: 'Group unit',
        placeholder: 'Select a group unit',
      },
      quantity: {
        label: 'Group quantity',
        placeholder: 'Set a group quantity',
      },
    },
    budgetThreshold: {
      label: 'Budget threshold percentage',
      placeholder: 'Set a budget threshold percentage',
      message:
        'Set budget thresholds to flag when a section or sub-section goes over the assigned percentage of the budget.',
    },
    buttons: {
      createAndClose: 'Create and Close',
      createAndNew: 'Create and New',
      groupItems: 'Group selected items',
    },
  },
  deleteSelectedItems: {
    title: 'Delete selected line items',
    line1: '{count} Line item{plural} selected',
    line2: `You've selected to delete line items from your BOQ.`,
    line3: 'Are you sure?',
    message: 'This action cannot be undone',
  },
  groupSelectedItems: {
    title: 'Group selected line items',
    groupSelectedItemsTooltip: 'Group selected items',
    groupSelectedItemsNotAllowedTooltip:
      'One or more of the selected items is already in a group, only items not already in a group can be added to a new group.',
  },
};
